import React from "react";

// reactstrap components
import {
    Card,
    CardBody,
    CardTitle,
    Container,
    Progress,
    Row,
    Col
} from "reactstrap";

// core components
import ExamplesNavbar from "./components/LandingNavbar.js";
import LandingPageHeader from "./components/LandingPageHeader";
import ExperienceCard from "./components/ExperienceCard";
import SkillsCard from "./components/SkillsCard"
import ResumeCard from "./components/ResumeCard";
import Footer from "./components/Footer";

function LandingPage() {
    document.documentElement.classList.remove("nav-open");
    React.useEffect(() => {
        console.log("landing page useeffect");
        document.body.classList.add("profile-page");
        return function cleanup() {
            document.body.classList.remove("profile-page");
        };
    });
    return (
        <>
            <ExamplesNavbar />
            <LandingPageHeader />
            <div className="main">
                <div className="section text-center">
                    <Container>
                        <Row>
                            <Col className="ml-auto mr-auto" md="8">
                                <h2 className="title">About Me</h2>
                                <h5 className="description">
                                    With a Bachelor in Information Technology I have been in the I.T field for over 10 years.
                                    I have extensive experience gathering requirements, designing, implementing and testing different types of systems.
                                    I am also very accomplished in leading empowered, globally distributed and effective engineering teams.
                                </h5>
                                <br />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <ExperienceCard/>
                <SkillsCard />
                <ResumeCard />
            </div>
            <Footer />
        </>
    );
}

export default LandingPage;
